var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"md":"12","sm":"12","lg":"12"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.help[_vm.language])}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }